// Cleanup functions for pull-to-load functionality

import { handleWheel, handleScroll, handleTouchStart, handleTouchMove, handleTouchEnd } from './event-handlers.js';
import { 
    getAnimationFrameId,
    setAnimationFrameId,
    getPullIndicator,
    setPullIndicator,
    setTargetDistance,
    setCurrentDisplayDistance
} from './state.js';

/**
 * Remove pull indicator
 */
export function removePullIndicator() {
    const animationFrameId = getAnimationFrameId();
    if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        setAnimationFrameId(null);
    }
    setTargetDistance(0);
    setCurrentDisplayDistance(0);
    const pullIndicator = getPullIndicator();
    if (pullIndicator && pullIndicator.parentNode) {
        pullIndicator.parentNode.removeChild(pullIndicator);
        setPullIndicator(null);
    }
}

/**
 * Cleanup pull-to-load listeners
 */
export function cleanupPullToLoad() {
    window.removeEventListener('wheel', handleWheel, { passive: false });
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('touchstart', handleTouchStart, { passive: true });
    window.removeEventListener('touchmove', handleTouchMove, { passive: false });
    window.removeEventListener('touchend', handleTouchEnd, { passive: true });
    
    // Remove visualViewport listeners
    if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', handleScroll);
        window.visualViewport.removeEventListener('resize', handleScroll);
    }
    
    removePullIndicator();
}

